<template>
  <div class="card" style="width: 14rem">
    <img class="card-img-top" :src="link" />
    <div class="card-body">
      <h5 class="card-title">{{ title }}</h5>
      <div class="ql-editor" v-html="msg"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Cards",
  props: {
    title: String,
    msg: String,
    link: String,
  },
};
</script>
<style scoped>
.card-title {
  text-align: center;
}
.card-text {
  text-align: center;
}
img {
  padding-top: 40px;
  height: 120px;
}
.card {
  margin: 20px;
  border: 2px solid black;
  background: #fff;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.08), 0 0 6px rgba(0, 0, 0, 0.05);
  transition: 0.3s transform cubic-bezier(0.155, 1.105, 0.295, 1.12),
    0.3s box-shadow,
    0.3s -webkit-transform cubic-bezier(0.155, 1.105, 0.295, 1.12);
  cursor: pointer;
}
</style>
